/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface InviteAccountUserParams { 
    /**
     * Account Id
     */
    account_id: string;
    /**
     * Email address
     */
    email: string;
    /**
     * User Role
     */
    role: InviteAccountUserParams.RoleEnum;
}
export namespace InviteAccountUserParams {
    export type RoleEnum = 'owner' | 'admin' | 'developer' | 'analyst' | 'view_only' | 'account_manager' | 'onboarding_sales_rep' | 'restricted_view_only' | 'merchant_owner' | 'merchant_admin' | 'merchant_view_only' | 'reseller_owner' | 'reseller_admin' | 'reseller_view_only' | 'reseller_sales_rep' | 'reseller_support_specialist' | 'reseller_integration_analyst';
    export const RoleEnum = {
        OWNER: 'owner' as RoleEnum,
        ADMIN: 'admin' as RoleEnum,
        DEVELOPER: 'developer' as RoleEnum,
        ANALYST: 'analyst' as RoleEnum,
        VIEW_ONLY: 'view_only' as RoleEnum,
        ACCOUNT_MANAGER: 'account_manager' as RoleEnum,
        ONBOARDING_SALES_REP: 'onboarding_sales_rep' as RoleEnum,
        RESTRICTED_VIEW_ONLY: 'restricted_view_only' as RoleEnum,
        MERCHANT_OWNER: 'merchant_owner' as RoleEnum,
        MERCHANT_ADMIN: 'merchant_admin' as RoleEnum,
        MERCHANT_VIEW_ONLY: 'merchant_view_only' as RoleEnum,
        RESELLER_OWNER: 'reseller_owner' as RoleEnum,
        RESELLER_ADMIN: 'reseller_admin' as RoleEnum,
        RESELLER_VIEW_ONLY: 'reseller_view_only' as RoleEnum,
        RESELLER_SALES_REP: 'reseller_sales_rep' as RoleEnum,
        RESELLER_SUPPORT_SPECIALIST: 'reseller_support_specialist' as RoleEnum,
        RESELLER_INTEGRATION_ANALYST: 'reseller_integration_analyst' as RoleEnum
    };
}


